import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, UntypedFormGroup } from '@angular/forms';
import { transitionHeight } from 'animations-lib';
import { IDocumentType } from 'document-type-picker-lib';
import { IDestinationsForOutputFileType } from '../../../services/entity-type/entity-type-service.factory';

@Component({
  selector: 'app-document-destination-filetype',
  templateUrl: './document-destination-filetype.component.html',
  styleUrls: ['./document-destination-filetype.component.scss'],
  animations: [transitionHeight],
  standalone: false,
})
export class DocumentDestinationFileTypeComponent {
  @Input() documentDestinationOptionsAllowed: boolean;
  @Input() documentDestinationFormGroup: UntypedFormGroup;
  @Input() destinationsForOutputFileType: IDestinationsForOutputFileType[];
  @Input() outputFileTypeSectionFormGroup: FormGroup;
  @Input() fileTypeOptionsAllowed: boolean;
  @Input() entityType: string | null;
  @Input() namespace;
  @Input() forSignature = false;
  @Output() updateDocumentForDestinationType = new EventEmitter<{
    destinationType: string;
    documentType: IDocumentType;
  }>();
}
